import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
import { AuthGuard } from './_helper/auth.guard';
import { HomeComponent } from './report/home/home.component';

const routes: Routes = [
  //   { path: 'home', component: LayoutComponent , children: [
  //     { path: 'module/:id', component: HomeComponent },
  //  ]},

  {
    path: 'pages',
    loadChildren: () =>
      import('./extrapages/extrapages.module').then((m) => m.ExtrapagesModule),
    canActivate: [AuthGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountModule),
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./account/account.module').then((m) => m.AccountModule),
  },
  // { path: 'salesinvoice', component: LayoutComponent, loadChildren: () => import('./salesinvoice/salesinvoice.module').then(m => m.SalesInvoiceModule) },
  {
    path: 'home',
    component: LayoutComponent,
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'inventory',
    component: LayoutComponent,
    loadChildren: () =>
      import('./inventory/inventory.module').then((m) => m.InventoryModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'ledgertransaction',
    component: LayoutComponent,
    loadChildren: () =>
      import('./ledger-transaction/ledgertransaction.module').then(
        (m) => m.LedgerTransactionModule
      ),
    canActivate: [AuthGuard],
  },

  {
    path: 'purchase',
    component: LayoutComponent,
    loadChildren: () =>
      import('./purchase/purchase.module').then((m) => m.PurchaseModule),
    canActivate: [AuthGuard]
  },
  ,
  {
    path: 'sales',
    component: LayoutComponent,
    loadChildren: () =>
      import('./sales/sales.module').then((m) => m.SalesModule),
    canActivate: [AuthGuard],
  },
  ,
  {
    path: 'ledger',
    component: LayoutComponent,
    loadChildren: () =>
      import('./ledger/ledger.module').then((m) => m.LedgerModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'master',
    component: LayoutComponent,
    loadChildren: () =>
      import('./master/master.module').then((m) => m.MasterModule),
    canActivate: [AuthGuard],
  },
  ,
  {
    path: 'setting',
    component: LayoutComponent,
    loadChildren: () =>
      import('./setting/setting.module').then((m) => m.SettingModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'inventorymanagement',
    component: LayoutComponent,
    loadChildren: () =>
      import('./inventorymanagement/inventorymanagement.module').then(
        (m) => m.InventoryManagementModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'systemhub',
    component: LayoutComponent,
    loadChildren: () =>
      import('./systemhub/systemhub.module').then((m) => m.SystemhubModule),
    canActivate: [AuthGuard],
  },
   {
    path: 'hospitalmanagement',
    component: LayoutComponent,
    loadChildren: () =>
      import('./hospital/hospital.module').then((m) => m.HospitalModule),
      canActivate: [AuthGuard],
  },
  // ,{ path: 'report', component: LayoutComponent, loadChildren: () => import('./report/report.module').then(m => m.ReportModule),canActivate: [AuthGuard]}

  { path: 'report', component: HomeComponent },

  {
    path: 'reports',
    component: LayoutComponent,
    loadChildren: () =>
      import('./report/ReportModule').then((mod) => mod.ReportModule),
    data: { preload: true },
    canActivate: [AuthGuard]
  },

//   {
//   path: 'academic',
//   component: LayoutComponent,
//   loadChildren: () =>
//     import('./academic/academic.module').then((m) => m.AcademicModule),
//   canActivate: [AuthGuard],
// }
  // {
  //   path: 'academic',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //     import('./academic/academic.module').then((m) => m.AcademicModule),
  // },

  // {
  //   path: 'exam',
  //   component: LayoutComponent,
  //   loadChildren: () =>
  //       import('./academic/exam/exam.module').then((m) => m.ExamModule),
  // },
,{
    path: 'tds',
    component: LayoutComponent,
    loadChildren: () =>
      import('./tds/tds-routing.module').then((mod) => mod.TDSRoutingModule),
    data: { preload: true },
    canActivate: [AuthGuard]
  },

  {
    path: 'academic',
    children: [
      {
        path: 'fee',
        component: LayoutComponent,
        loadChildren: () =>
          import('./academic/fee/fee-routing.module').then((m) => m.FeeRoutingModule),
      },
        {
        path: 'admission',
        component: LayoutComponent,
        loadChildren: () =>
          import('./academic/admission/admission-routing.module').then((m) => m.AdmissionRoutingModule),
      },
        {
        path: 'attendance',
        component: LayoutComponent,
        loadChildren: () =>
          import('./academic/attendance/attendance-routing.module').then((m) => m.AttendanceRoutingModule),
      },
        {
        path: 'student',
        component: LayoutComponent,
        loadChildren: () =>
          import('./academic/student/student-routing.module').then((m) => m.studentattendanceRoutingModule),
      },
      {
        path: 'exam',
        component: LayoutComponent,
        loadChildren: () =>
          import('./academic/exam/exam-routing.module').then((m) => m.ExamRoutingModule),
      },

      {
        path: 'master',
        component: LayoutComponent,
        loadChildren: () =>
          import('./academic/master/master-routing.module').then((m) => m.MasterRoutingModule),
      },

      {
        path: 'setup',
        component: LayoutComponent, 
        loadChildren: () =>
          import('./academic/setup/setup-routing.module').then((m) => m.SetupRoutingModule),
      },
        {
        path: 'report',
        component: LayoutComponent,
        loadChildren: () =>
          import('./academic/academicreport/academicreport-routing.module').then((m) => m.AcademicreportRoutingModule),
      },
       {
        path: 'library',
        component: LayoutComponent,
        loadChildren: () =>
          import('./academic/library/library-routing.modul').then((m) => m.LibraryRoutingModule),
      },
    ],
  },
   {
    path: 'transport',
    children: [
      {
        path: 'entry',
        component: LayoutComponent,
        loadChildren: () =>
          import('./transport/entry/entry-routing.module').then((m) => m.EntryRoutingModule),
      },
       

      {
        path: 'report',
        component: LayoutComponent,
        loadChildren: () =>
          import('./transport/report/report-routing.module').then((m) => m.ReportRoutingModule),
      },

      {
        path: 'master',
        component: LayoutComponent,
        loadChildren: () =>
          import('./transport/setup/setup-routing.module').then((m) => m.SetupRoutingModule),
      },


    ],
  },

  {
    path: 'tds',
    children: [
      {
        path: 'entry',
        component: LayoutComponent,
        loadChildren: () =>
          import('./transport/entry/entry-routing.module').then((m) => m.EntryRoutingModule),
      }
    ],
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
